import type { SxProps, Theme } from "@mui/material/styles";

export const authPrimaryButtonSx: SxProps<Theme> = {
  height: 48,
  minHeight: 48,
  py: 0,
  px: 1.5,
  position: "relative",
  borderRadius: "var(--radius-lg)",
  border: "1px solid transparent",
  textTransform: "none",
  fontFamily: "var(--type-button-font-family)",
  fontWeight: "var(--type-button-font-weight)",
  fontSize: "var(--type-button-font-size)",
  lineHeight: "var(--type-button-line-height)",
  letterSpacing: "normal",
  backgroundColor: "var(--primary)",
  color: "var(--primary-foreground)",
  boxShadow: "none",
  transition:
    "color 150ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease",
  "&:hover": {
    backgroundColor: "color-mix(in oklab, var(--primary) 80%, transparent)",
    boxShadow: "none",
  },
  "&:active": {
    transform: "translateY(1px)",
  },
  "&.Mui-disabled": {
    backgroundColor: "var(--primary)",
    color: "var(--primary-foreground)",
    opacity: 0.5,
  },
};
